import { ArrowIcon } from "./LandingIcons";

interface LandingHeroProps {
  onRequestAccess: () => void;
}

const PROBLEM_SHIFTS = [
  ["Shared gateway", "Isolated environment"],
  ["Manual checks", "Retained evidence"],
  ["Hidden blockers", "Readiness gate"],
] as const;

export default function LandingHero({ onRequestAccess }: LandingHeroProps) {
  return (
    <>
      <section className="oc-hero" id="platform" aria-labelledby="hero-title">
        <div className="oc-site-shell oc-hero__grid">
          <div className="oc-hero__copy">
            <p className="oc-eyebrow">
              Development + automated testing for Ignition
            </p>
            <h1 id="hero-title">Prove Ignition changes before production.</h1>
            <p className="oc-hero__dek">
              OrbitCell brings isolated 8.1 and 8.3 environments, Native Vision
              evidence, and readiness gates into one control plane&mdash;so teams
              can test risky changes with the real blockers visible.
            </p>
            <div className="oc-hero__actions">
              <button
                className="oc-button oc-button--primary oc-button--large"
                type="button"
                onClick={onRequestAccess}
              >
                Request preview access
              </button>
              <a className="oc-button oc-button--secondary oc-button--large" href="#workflow">
                See how it works
                <ArrowIcon />
              </a>
            </div>
            <p className="oc-hero__qualifier">
              <span aria-hidden="true" />
              Closed technical preview <b>&middot;</b> onboarding follows current
              capability readiness
            </p>
          </div>

          <div className="oc-hero__visual" aria-label="OrbitCell product dashboard">
            <div className="oc-product-frame">
              <div className="oc-product-frame__bar" aria-hidden="true">
                <span />
                <span />
                <span />
                <b>orbitcell.io</b>
              </div>
              <img
                src="/screens/slide-01-dashboard.png"
                alt="OrbitCell environment dashboard showing readiness and recent test activity"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="oc-problem" aria-labelledby="problem-title">
        <div className="oc-site-shell">
          <div className="oc-section-intro oc-section-intro--wide">
            <p className="oc-eyebrow">The operating problem</p>
            <h2 id="problem-title">Production should not be your first feedback loop.</h2>
            <p>
              Shared gateways, manual click-through, and hand-carried backups turn
              every change into a commissioning risk.
            </p>
          </div>
          <div className="oc-shift-rail" aria-label="OrbitCell workflow shifts">
            {PROBLEM_SHIFTS.map(([from, to]) => (
              <div className="oc-shift" key={from}>
                <span>{from}</span>
                <ArrowIcon />
                <strong>{to}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
